import React from 'react';
import { checkParitySuccess } from '../utilities';
import { removeParity } from '../utilities';
import { SENDER_ACTIONS } from '../models/Engine';

const useQrScanner = () => {
  const [isLoading, setIsLoading] = React.useState(false);

  React.useEffect(() => {
    document.addEventListener('keydown', readScanner);
    return () => {
      document.removeEventListener('keydown', readScanner);
    };
  }, []);

  //QR SCANNER APPENDS LETTERS ON SHIFT PRESS AND ENTER TRIGGERS SCAN

  let qrValue = '';
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const readScanner = (val: any) => {
    if (!isLoading) {
      setIsLoading(true);
      if (val.key === 'Enter') {
        const temp = qrValue;
        console.log('scanned text | ', temp);
        handleScan(temp);
        setIsLoading(false);
        qrValue = '';
      } else if (val.key !== 'Shift') {
        qrValue += val.key;
      }
    }
  };

  const handleScan = (value: string) => {
    const isValid = checkParitySuccess(value);
    if (isValid) {
      const data = removeParity(value);
      window.SENDER({ type: SENDER_ACTIONS.SEND_QR_DATA, payload: data });
    }
  };
};

export default useQrScanner;
